"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";
import CuoButton from "@/app/admin/_common/CuoButton";
import { useLocationsModel } from "./locationsPageModel";
import LocationsToolbar from "./_cmp/LocationsToolbar";
import LocationList from "./_cmp/LocationList";
import LocationListSkeleton from "./_cmp/LocationListSkeleton";
import LocationsMap from "./_cmp/LocationsMap";
import LocationsMapSkeleton from "./_cmp/LocationsMapSkeleton";
import { LocationDialog } from "./_cmp/locationForm/LocationDialog";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";
import { PlusCircle, Building2 } from "lucide-react";

export default function LocationsPage() {
  const {
    filteredLocations,
    isLoading,
    search,
    setSearch,
    selectedLocation,
    setSelectedLocation,
    openForm,
    openCreateForm,
    openEditForm,
    closeForm,
    handleDelete,
    refetch,
  } = useLocationsModel();
  const isMobile = useIsMobile();

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader
          title="Locations"
          icon={Building2}
          subtitle={`${filteredLocations.length} locations`}
          actions={
            <CuoButton
              variant={isMobile ? "outline" : "default"}
              label={<span className="hidden sm:inline">Add location</span>}
              icon={<PlusCircle className="size-3.5 shrink-0" size={14} />}
              onClick={openCreateForm}
              className="px-2 sm:px-3"
              aria-label="Add location"
            />
          }
        />

        <div className="flex min-h-0 flex-1 flex-col gap-3 px-3 py-5 md:px-5">
          <LocationsToolbar search={search} onSearchChange={setSearch} />

          <div className="flex min-h-0 flex-1 gap-3">
            <div className="-mx-3 min-h-0 min-w-0 flex-1 md:mx-0 md:flex-none md:basis-[60%]">
              {isLoading ? (
                <LocationListSkeleton />
              ) : (
                <LocationList
                  locations={filteredLocations}
                  selectedLocation={selectedLocation}
                  onSelectLocation={setSelectedLocation}
                  onEdit={openEditForm}
                  onDelete={handleDelete}
                />
              )}
            </div>
            <div className="hidden min-w-0 md:block md:basis-[40%]">
              {isLoading ? (
                <LocationsMapSkeleton />
              ) : (
                <LocationsMap
                  locations={filteredLocations}
                  selectedLocation={selectedLocation}
                  onSelectLocation={setSelectedLocation}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <LocationDialog
        open={openForm}
        defaultLocation={selectedLocation}
        onClose={closeForm}
        onSaved={refetch}
      />
    </PageContainer>
  );
}
